import * as React from 'react'
import { GetDelayTreeTiles, animationFadeInUp } from '../constants'

export interface IContentCard {
  index: number
  linkLabel: string
  link: string
  heading: string
  imageUrl: string
  imageAltText: string
  teaser: string
}

function ContentCard({
  index,
  linkLabel,
  link,
  heading,
  imageUrl,
  imageAltText,
  teaser,
}: IContentCard) {
  return (
    <a
      className={`group h-full grid  grid-rows-[auto_1fr] gap-4 md:gap-5 ${animationFadeInUp} ${GetDelayTreeTiles(
        index
      )}`}
      href={link}
      key={heading}
    >
      <div className="inline-block overflow-hidden aspect-video h-full">
        <img
          className="img-zoom-group-hover object-cover"
          src={imageUrl}
          alt={imageAltText}
        />
      </div>
      <div className="flex items-baseline flex-col h-full justify-between gap-4">
        <div className="inline-flex flex-col gap-4 md:gap-5">
          {heading && <h3 className="text-md">{heading}</h3>}
          {teaser && <p className="line-clamp-3">{teaser}</p>}
        </div>
        <p className="link link-text group-hover:border-engineering-grey-1 self-start">
          {linkLabel}
        </p>
      </div>
    </a>
  )
}

export default ContentCard
